import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LogoLockup } from './Logo';

/**
 * MIRROR footer
 * - No emoji (the legacy 🇩🇰 flag is gone — doctrine forbids emoji in copy).
 * - No "all systems operational" pulse-dot — gamified status indicators are
 *   not in the doctrine. Status reporting moves to a status sub-domain when
 *   needed.
 * - No brand-colour accent on "Node" — the wordmark is uniform ink.
 */
export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border py-12 px-6" data-testid="site-footer">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div className="space-y-2">
            <LogoLockup size={20} />
            <p className="text-xs text-muted-foreground pt-2" data-testid="footer-vat">
              DACEUR &middot; VAT: DK31405920
            </p>
            {/*
              Display email follows DNS-cut to verumq.com. Backend SENDER_EMAIL
              is switched in Render once Resend domain verification completes
              (see dns_migration_plan.md Step 11).
            */}
            <p className="text-xs text-muted-foreground">hello@verumq.com</p>
            <p className="text-xs text-muted-foreground/70">Built in Denmark</p>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-wider">
            <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-pricing-link">
              {t('footer.pricing')}
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy-link">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms-link">
              {t('footer.terms')}
            </Link>
            <Link to="/imprint" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-imprint-link">
              {t('footer.imprint')}
            </Link>
            <Link to="/cookies" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-cookies-link">
              {t('footer.cookies')}
            </Link>
          </nav>
        </div>

        <hr className="rule mt-8 mb-6" />

        <p className="text-xs text-muted-foreground">
          &copy; {year} DACEUR. {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
}
